import { __decorate, __extends, __spreadArrays } from "tslib";
import NavPanel from '@/components/common/NavPanel.vue';
import AvalonGTView from '@/utils/libs/BaseView';
import { Options } from 'vue-class-component';
import NavSelect from '@/components/assist/navSelect.vue';
import { PageService } from '@/views/copy/invite/import';
import Backpack from '@/views/copy/mall/page/Backpack.vue';
import AvalonGTGlobal from '@/utils/factory/Global';
var View = /** @class */ (function (_super) {
    __extends(View, _super);
    function View() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.reportList = [];
        _this.loading = true; //@ 2021/12/22 14:27 是否加载
        _this.finished = false; //@ 2021/12/22 14:28 是否已加载完成，完成后不再出发load事件
        _this.pageIndex = 1; //@ 2021/12/21 17:32 分页的页数
        _this.selectModel = 0; // 2023/10/18 9:48  选中的内容
        _this.lastId = 0; // 2023/10/29 16:49 列表最后一个id
        _this.selectActive = 0;
        _this.params = {};
        _this.enableBtn = false; // 2023/12/19 13:16  是否隐藏导出按钮
        _this.downloadUrl = ''; // 下载链接
        return _this;
    }
    View.prototype.mounted = function () {
        this.params = this.$route.query;
        this.getList();
        this.getDownloadUrl();
        // localStorage.setItem('inviteTabIndex', '2');
    };
    //@ 2021/12/22 14:26 加载数据
    View.prototype.onLoad = function (val) {
        console.log('onLoad');
        this.loading = true;
        this.finished = false;
        this.pageIndex++;
        //@ 2021/12/22 17:22 请求接口
        this.getList();
    };
    View.prototype.getList = function () {
        var _this = this;
        PageService.inviteRewardDetailRecord({
            page: this.pageIndex,
            day: this.params.date,
        }).then(function (data) {
            if (_this.pageIndex == 1) {
                _this.enableBtn = Number(data.enable) == 1;
            }
            if (data.list) {
                if (data.list.length != 0 && _this.pageIndex != 1) {
                    _this.reportList = __spreadArrays(_this.reportList, data.list);
                }
                else if (data.list.length != 0 && _this.pageIndex == 1) {
                    _this.reportList = data.list;
                }
                else {
                    _this.finished = true;
                }
                // this.lastId = data.lastId;
                _this.loading = false;
            }
            else {
                if (_this.pageIndex == 1) {
                    _this.reportList = [];
                }
                _this.finished = true;
                _this.loading = false;
            }
        });
    };
    View.prototype.selectHandle = function (val) {
        this.selectActive = val;
        this.lastId = 0;
        this.loading = true;
        this.finished = false;
        this.getList();
    };
    View.prototype.getDownloadUrl = function () {
        var _this = this;
        PageService.exportInviteExcel({
            day: this.params.date,
        }).then(function (data) {
            _this.downloadUrl = data.url;
        });
    };
    View.prototype.toBack = function () {
        this.$router.go(-1);
    };
    View.prototype.exportExcel = function () {
        AvalonGTGlobal.copyText(this.downloadUrl.toString(), '快去浏览器下载吧');
    };
    View = __decorate([
        Options({
            name: 'reportRecord',
            components: { Backpack: Backpack, NavSelect: NavSelect, NavPanel: NavPanel },
        })
    ], View);
    return View;
}(AvalonGTView.BaseView));
export default View;
